module.exports = __webpack_public_path__ + "img/1高电压技术.f8e48183.jpg";